import type { GeneticSexFormValue } from '../../utils/geneticSex';

export type RelationshipOption = 'parent' | 'sibling' | 'child' | 'spouse';

export interface ModifyRelativeFormValues {
  relationship: RelationshipOption;
  firstName: string;
  lastName: string;
  geneticSex: GeneticSexFormValue;
  birthDate: Date | null;
  deathDate: Date | null;
  causeOfDeath?: string;
  profileImageUrl: string | null;
}

export const defaultValues: ModifyRelativeFormValues = {
  relationship: 'parent',
  firstName: '',
  lastName: '',
  geneticSex: 'male',
  birthDate: null,
  deathDate: null,
  causeOfDeath: '',
  profileImageUrl: null,
};

export const relationshipSelectOptions = [
  { value: 'parent', label: 'Parent' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'child', label: 'Child' },
  { value: 'spouse', label: 'Spouse' },
] as const;

export const geneticSexOptions = [
  { value: 'female', label: 'Female (XX)' },
  { value: 'male', label: 'Male (XY)' },
  { value: 'unspecified', label: 'Prefer not to say' },
] as const;
